'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var debug = require('debug');

var multihashing = require('multihashing-async');

var mh = require('multihashes');

var _require = require('interface-datastore'),
    Key = _require.Key;

var base32 = require('base32.js');

var distance = require('xor-distance');

var pMap = require('p-map');

var _require2 = require('libp2p-record'),
    Record = _require2.Record;

var PeerId = require('peer-id');

var errcode = require('err-code');

var _require3 = require('buffer'),
    Buffer = _require3.Buffer;
/**
 * Creates a DHT ID by hashing a given buffer.
 *
 * @param {Buffer} buf
 * @returns {Promise<Buffer>}
 */


exports.convertBuffer = function (buf) {
  return multihashing.digest(buf, 'sha2-256');
};
/**
 * Creates a DHT ID by hashing a Peer ID
 *
 * @param {PeerId} peer
 * @returns {Promise<Buffer>}
 */


exports.convertPeerId = function (peer) {
  return multihashing.digest(peer.id, 'sha2-256');
};
/**
 * Convert a buffer to their SHA2-256 hash.
 *
 * @param {Buffer} buf
 * @returns {Key}
 */


exports.bufferToKey = function (buf) {
  return new Key('/' + exports.encodeBase32(buf), false);
};
/**
 * Generate the key for a public key.
 *
 * @param {PeerId} peer
 * @returns {Buffer}
 */


exports.keyForPublicKey = function (peer) {
  return Buffer.concat([Buffer.from('/pk/'), peer.id]);
};

exports.isPublicKeyKey = function (key) {
  return key.slice(0, 4).toString() === '/pk/';
};

exports.fromPublicKeyKey = function (key) {
  return new PeerId(key.slice(4));
};
/**
 * Get the current time as timestamp.
 *
 * @returns {number}
 */


exports.now = function () {
  return Date.now();
};
/**
 * Encode a given buffer into a base32 string.
 * @param {Buffer} buf
 * @returns {string}
 */


exports.encodeBase32 = function (buf) {
  var enc = new base32.Encoder();
  return enc.write(buf).finalize();
};
/**
 * Decode a given base32 string into a buffer.
 * @param {string} raw
 * @returns {Buffer}
 */


exports.decodeBase32 = function (raw) {
  var dec = new base32.Decoder();
  return Buffer.from(dec.write(raw).finalize());
};
/**
 * Sort peers by distance to the given `target`.
 *
 * @param {Array<PeerId>} peers
 * @param {Buffer} target
 * @returns {Array<PeerId>}
 */


exports.sortClosestPeers = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peers, target) {
    var distances;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return pMap(peers, /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer) {
                var id;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return exports.convertPeerId(peer);

                      case 2:
                        id = _context.sent;
                        return _context.abrupt("return", {
                          peer: peer,
                          distance: distance(id, target)
                        });

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 2:
            distances = _context2.sent;
            return _context2.abrupt("return", distances.sort(exports.xorCompare).map(function (d) {
              return d.peer;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Compare function to sort an array of elements which have a distance property which is the xor distance to a given element.
 *
 * @param {Object} a
 * @param {Object} b
 * @returns {number}
 */


exports.xorCompare = function (a, b) {
  return distance.compare(a.distance, b.distance);
};
/**
 * Computes how many results to collect on each disjoint path, rounding up.
 * This ensures that we look for at least one result per path.
 *
 * @param {number} resultsWanted
 * @param {number} numPaths - total number of paths
 * @returns {number}
 */


exports.pathSize = function (resultsWanted, numPaths) {
  return Math.ceil(resultsWanted / numPaths);
};
/**
 * Create a new put record, encodes and signs it if enabled.
 *
 * @param {Buffer} key
 * @param {Buffer} value
 * @returns {Buffer}
 */


exports.createPutRecord = function (key, value) {
  var timeReceived = new Date();
  var rec = new Record(key, value, timeReceived);
  return rec.serialize();
};
/**
 * Creates a logger for the given subsystem
 *
 * @param {PeerId} [id]
 * @param {string} [subsystem]
 * @returns {debug}
 *
 * @private
 */


exports.logger = function (id, subsystem) {
  var name = ['libp2p', 'dht'];

  if (subsystem) {
    name.push(subsystem);
  }

  if (id) {
    name.push("".concat(id.toB58String().slice(0, 8)));
  } // Add a formatter for converting to a base58 string


  debug.formatters.b = function (v) {
    return mh.toB58String(v);
  };

  var logger = debug(name.join(':'));
  logger.error = debug(name.concat(['error']).join(':'));
  return logger;
};

exports.TimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(TimeoutError, _Error);

  var _super = _createSuper(TimeoutError);

  function TimeoutError() {
    _classCallCheck(this, TimeoutError);

    return _super.apply(this, arguments);
  }

  _createClass(TimeoutError, [{
    key: "code",
    get: function get() {
      return 'ETIMEDOUT';
    }
  }]);

  return TimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Creates an async function that calls the given `asyncFn` and Errors
 * if it does not resolve within `time` ms
 *
 * @param {Function} [asyncFn]
 * @param {Number} [time]
 * @returns {Function}
 *
 * @private
 */


exports.withTimeout = function (asyncFn, time) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Promise.race([asyncFn.apply(void 0, _args3), new Promise(function (resolve, reject) {
              setTimeout(function () {
                reject(errcode(new Error('Async function did not complete before timeout'), 'ETIMEDOUT'));
              }, time);
            })]));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};